import React from 'react';

const CONTEXT_KEY = Symbol.for('@thd-olt-component-react/router/context');
const globalSymbols = Object.getOwnPropertySymbols(global);
const hasContext = (globalSymbols.indexOf(CONTEXT_KEY) > -1);

if (!hasContext) {
  global[CONTEXT_KEY] = React.createContext({
    paths: []
  });
}

export default global[CONTEXT_KEY];
